export default {
    id: null,
    pessoa: null,
    comissao: false,
    config: {},
    active: true
}
